import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";

export const AddOfferModal = ({ isOpen, setIsOpen }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      className="relative z-50"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 flex w-screen items-center justify-center  p-4">
        <DialogPanel className="max-w-lg space-y-4 border bg-white rounded-lg">
          <div className="p-8">
            <DialogTitle className="text-xl uppercase pb-4">
              New Offer
            </DialogTitle>
            <form className="w-full">
              <div className="flex flex-wrap -mx-3">
                <div className="w-full px-3 mb-4">
                  <label
                    className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                    htmlFor="grid-first-name"
                  >
                    School
                  </label>
                  <input
                    className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white placeholder-gray-900"
                    id="School"
                    type="text"
                    placeholder="School..."
                  />
                </div>
                <div className="w-full px-3 mb-4">
                  <label
                    className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                    htmlFor="SecondaryPosition"
                  >
                    Division
                  </label>
                  <div className="relative">
                    <select
                      className="form-select bg-no-repeat block appearance-none w-full border border-gray-300 text-gray-900 p-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="SecondaryPosition"
                    >
                      <option>D1</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                  </div>
                </div>
                <div className="w-full px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                    htmlFor="Year"
                  >
                    Year
                  </label>
                  <input
                    className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white placeholder-gray-900"
                    id="Year"
                    type="text"
                    placeholder="Year..."
                  />
                </div>
              </div>
            </form>
          </div>

          <div className="flex gap-4 bg-gray-50 sm:flex sm:flex-row-reverse p-4">
            <button
              className="bg-red-500 text-white p-3 px-10 rounded-md uppercase text-sm hover:bg-red-700  ml-3"
              onClick={() => setIsOpen(false)}
            >
              Add
            </button>
            <button onClick={() => setIsOpen(false)}>Cancel</button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};
